import React, { useState } from 'react';

import {
  Button,
  Divider,
  Flex,
  HStack,
  Heading,
  Input,
} from '@chakra-ui/react';

import {
  IconCheck,
  IconEditPencilOutline,
  IconXCloseBlack,
} from '@/components';

interface InterviewTitleWithEditProps {
  title: string;
  onEdit: (newTitle: string) => void;
}

export const InterviewTitleWithEdit: React.FC<InterviewTitleWithEditProps> = ({
  title,
  onEdit,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [currentTitle, setCurrentTitle] = useState(title);

  const handleSave = () => {
    onEdit(currentTitle);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setCurrentTitle(title);
    setIsEditing(false);
  };

  return (
    <Flex alignItems="center" gap={2}>
      <Flex justifyItems="center" alignItems="center" minW={0} columnGap={4}>
        <>
          {title && (
            <Flex
              columnGap={2}
              role="group"
              alignItems="center"
              borderRadius="8px"
              bg={isEditing ? 'gray.25' : 'auto'}
              borderWidth={isEditing ? '1px' : 'auto'}
              borderColor={isEditing ? 'gray.50' : 'auto'}
              _hover={{
                bg: 'gray.25',
                borderWidth: '1px',
                borderColor: 'gray.50',
              }}
            >
              {isEditing ? (
                <Input
                  h="10"
                  pl={3}
                  value={currentTitle}
                  onChange={(e) => setCurrentTitle(e.target.value)}
                  size="lg"
                  fontWeight="bold"
                  variant="unstyled"
                  width={
                    currentTitle.length > 20 ? currentTitle.length * 9 : 'auto'
                  }
                  maxWidth={600}
                  minWidth={250}
                  lineHeight="30px"
                />
              ) : (
                <Heading
                  pl={3}
                  py={2}
                  noOfLines={1}
                  overflowWrap="break-word"
                  fontSize="lg"
                  lineHeight="30px"
                  // isTruncated
                  maxWidth={700}
                >
                  {title}
                </Heading>
              )}
              {!isEditing && (
                <>
                  <Divider
                    borderColor="gray.50"
                    bgColor="black"
                    display="none"
                    _groupHover={{ display: isEditing ? 'none' : 'block' }}
                    orientation="vertical"
                    h={10}
                  />
                  <Button
                    variant="link"
                    display="none"
                    p={0}
                    onClick={() => setIsEditing(true)}
                    _groupHover={{ display: isEditing ? 'none' : 'block' }}
                    pr={2}
                  >
                    <IconEditPencilOutline color="black" fontSize="20px" />
                  </Button>
                </>
              )}
              {isEditing && (
                <HStack spacing={0}>
                  <Divider
                    borderColor="#E9EAED"
                    bgColor="black"
                    orientation="vertical"
                    h={10}
                  />
                  <Button variant="link" p={0} onClick={handleSave}>
                    <IconCheck color="black" fontSize="20px" />
                  </Button>
                  <Divider
                    borderColor="#E9EAED"
                    bgColor="black"
                    orientation="vertical"
                    h={10}
                  />
                  <Button variant="link" p={0} onClick={handleCancel}>
                    <IconXCloseBlack color="black" fontSize="20px" />
                  </Button>
                </HStack>
              )}
            </Flex>
          )}
        </>
      </Flex>
    </Flex>
  );
};
